/**
 * Mapping des enums Vinted → labels français
 */

const CONDITION_LABELS: Record<string, string> = {
  NEW_WITH_TAG: 'Neuf avec étiquette',
  NEW_WITHOUT_TAG: 'Neuf sans étiquette',
  VERY_GOOD_CONDITION: 'Très bon état',
  GOOD_CONDITION: 'Bon état',
  GOOD: 'Bon état',
  SATISFACTORY: 'Satisfaisant',
  SOME_PIECES_NOT_WORKING: 'Certaines pièces ne fonctionnent pas',
};

export const getConditionLabel = (condition: string): string => CONDITION_LABELS[condition] ?? condition;

// ─── Tiers visuels (couleur du Tag dans la feed) ───────────────────────
//
// 4 niveaux pour aider l'œil à scanner le feed : vert vif (neuf), teal
// (TBE), orange (bon état), rouge (satisfaisant et en-dessous).
export type ConditionTier = 'excellent' | 'good' | 'fair' | 'poor';

const LABEL_TO_TIER: Record<string, ConditionTier> = {
  'Neuf avec étiquette': 'excellent',
  'Neuf sans étiquette': 'excellent',
  'Très bon état': 'good',
  'Bon état': 'fair',
  Satisfaisant: 'poor',
  'Certaines pièces ne fonctionnent pas': 'poor',
};

export const getConditionTier = (label: string): ConditionTier | null => LABEL_TO_TIER[label] ?? null;

// Tier par ENUM (ProductItemCondition camelCase) — à préférer au lookup par
// label : le label affiché est désormais localisé et ne matche plus les clés
// françaises de LABEL_TO_TIER en anglais.
const CONDITION_TO_TIER: Record<string, ConditionTier> = {
  newWithTag: 'excellent',
  newWithoutTag: 'excellent',
  veryGoodCondition: 'good',
  goodCondition: 'fair',
  good: 'fair',
  satisfactory: 'poor',
  somePiecesNotWorking: 'poor',
};

export const getConditionTierFromCondition = (condition: string): ConditionTier | null =>
  CONDITION_TO_TIER[condition] ?? null;
